/* eslint-disable react/require-default-props */
import React from 'react'
import { ReportDialogOptions } from '@sentry/browser'
import { Primitive } from '@sentry/types'
import { ErrorBoundary, FallbackRender } from '@sentry/react'
import { User } from '../types'
import { sendToDatadog } from '../utils'

interface ISentryErrorBoundaryProps {
  tags: { [key: string]: Primitive }
  userWithIP: User
  fallback?: React.ReactElement | FallbackRender
  showDialog: boolean
  dialogOptions: ReportDialogOptions
}

interface IFallbackProps {
  error: any,
  componentStack: any,
}

function SentryErrorBoundary(props: React.PropsWithChildren<ISentryErrorBoundaryProps>) {
  const {
    tags, userWithIP, fallback, showDialog, dialogOptions, children,
  } = props

  const renderFallback = (fallbackProps: IFallbackProps) => {
    if (React.isValidElement(fallback)) {
      return React.cloneElement(fallback, fallbackProps)
    }
    return <p>Something went wrong.</p>
  }

  return (
    <ErrorBoundary
      beforeCapture={(scope, error) => {
        scope.setTags(tags)
        scope.setUser(userWithIP)
        sendToDatadog(error)
      }}
      fallback={renderFallback}
      showDialog={showDialog}
      dialogOptions={dialogOptions}
    >
      {children}
    </ErrorBoundary>
  )
}

export default SentryErrorBoundary
